<script setup lang="ts">
import type { SlugBodyItem } from '..';

defineProps<{ items: SlugBodyItem[] }>();
</script>

<template>
  <div class="gap-r12 lg:gap-r18 flex flex-col">
    <SlugBodyItem v-for="(item, i) in items" :key="i" :item />
  </div>
</template>
